import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { requestHealthCheck } from "../../store/actions/actions";

const HealthCheck = (props) => {
    useEffect(() => {
        props.requestHealthCheck();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            <span>Status : </span>
            <span
                className={
                    props.data.status === "OK" ? "text-success" : "text-danger"
                }
            >
                {props.data.status}
            </span>
            <br />
            <span>Message : </span>
            <span
                className={
                    props.data.status === "OK" ? "text-success" : "text-danger"
                }
            >
                {props.data.message}
            </span>
        </div>
    );
};

const mapStateToProps = (state) => ({ data: state.data });
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestHealthCheck,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(HealthCheck);
